import { motion } from "framer-motion";
import { MapContainer, TileLayer, Circle, CircleMarker, Popup } from "react-leaflet";
import { MapPin } from "lucide-react";
import "leaflet/dist/leaflet.css";

const CENTER = [48.7617, 1.8386]; // Les Mesnuls (78)

export const ZoneMap = () => {
  return (
    <section id="zone" className="py-28 lg:py-36 bg-[#F3EFE8]" data-testid="zone-map-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="max-w-3xl mb-14"
        >
          <p className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#9E5A38] mb-5">
            Secteur d'intervention
          </p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-normal tracking-tight leading-[1.15] text-[#1C1815]">
            20 km autour des Mesnuls
          </h2>
          <p className="mt-6 text-base sm:text-lg font-light leading-relaxed text-[#59524A]">
            Basé aux Mesnuls (Yvelines), Louis Larsson intervient sur tous les
            chantiers situés dans un rayon de 20 km : Montfort-l'Amaury, Houdan,
            Mantes-la-Jolie, Rambouillet et leurs alentours.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="relative rounded-sm overflow-hidden border border-[#1A1714]/10 shadow-[0_30px_60px_-30px_rgba(26,23,20,0.25)]"
        >
          <MapContainer
            center={CENTER}
            zoom={10}
            scrollWheelZoom={false}
            className="h-[420px] lg:h-[520px] w-full z-0"
            data-testid="zone-map"
          >
            <TileLayer
              url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            />
            <Circle
              center={CENTER}
              radius={20000}
              pathOptions={{ color: "#9E5A38", weight: 2, dashArray: "8 8", fillColor: "#9E5A38", fillOpacity: 0.07 }}
            />
            <CircleMarker
              center={CENTER}
              radius={9}
              pathOptions={{ color: "#1A1714", weight: 2.5, fillColor: "#9E5A38", fillOpacity: 1 }}
            >
              <Popup>Louis Larsson — Peinture &amp; Rénovation, Les Mesnuls (78)</Popup>
            </CircleMarker>
          </MapContainer>

          <div
            className="absolute bottom-5 left-5 z-[500] bg-[#FAF7F2]/92 backdrop-blur-md border border-[#1A1714]/10 rounded-sm px-6 py-5 shadow-lg max-w-xs"
            data-testid="zone-map-info"
          >
            <p className="flex items-center gap-2 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[#9E5A38] mb-2">
              <MapPin className="w-3.5 h-3.5" /> Basé aux Mesnuls
            </p>
            <p className="font-serif-display text-xl text-[#1C1815] leading-snug">
              Les Mesnuls (78)
            </p>
            <p className="mt-1.5 text-xs text-[#59524A] leading-relaxed">
              Le cercle pointillé délimite la zone desservie : 20 km autour de
              l'atelier. Déplacement et visite technique offerts dans ce rayon.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
